import './search.scss';

export default {
  input: 'search',
  searchButton: 'btn btn-primary',
  searchTermList: 'search-terms',
  searchTerm: 'query-param',
  clearButton: 'clear-filter',
}
